import Icon from '../../../components/Icon/Icon';

const SignupModal = () => (
  <div className="modal-content">
    <span className="modal-status-icon modal-status-icon--success"><Icon name="check" /></span>
    <h1 id="modal-title" className="modal-title">Bienvenido al LIS</h1>
    <p className="modal-text">Tu registro fue completado correctamente.</p>
  </div>
);

export default SignupModal;
